import RecommendedAlertHeaderContainer from './RecommendedAlertHeaderContainer';

export default RecommendedAlertHeaderContainer;
